import { EventEmitter, Feature } from '@tencent/workbench';
import BaseTitleBarFeature from '@framework/workbench/common/feature/base-titlebar-feature';

@Feature()
export class PrintFeature extends BaseTitleBarFeature {
    constructor(private eventEmitter: EventEmitter) {
        super();
    }

    public handlePrint() {
        this.getAppServices().viewableServiceLayer.printService.handlePrint();
    }

    public shouldHidePrint() {
        return this.getAppServices().viewableServiceLayer.printService.shouldHidePrint();
    }

    public shouldDisablePrint() {
        return this.getAppServices().viewableServiceLayer.printService.shouldDisablePrint();
    }
}
